export default __webpack_public_path__ + "static/media/B0001.b04e4c00.png";